import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import numeral from 'numeral';
import moment from 'moment';

import * as _ from 'lodash-es';

@Component({
    selector: 'recap-additional-security',
    templateUrl: './recap-additional-security.component.html',
    styleUrls: ['./recap-additional-security.component.scss'],
    standalone: false
})
export class RecapAdditionalSecurityComponent implements OnInit {
    /**
     * Event emitted to tell the parent to invoke the edit action
     *
     * @type {EventEmitter<string>}
     * @memberof RecapAdditionalSecurityComponent
     */
    @Output() stageChange: EventEmitter<string>;
    /**
     * Incoming load details data form the parent
     *
     * @type {Object}
     * @memberof RecapAdditionalSecurityComponent
     */
    @Input() additionalDetails: Object;
    /**
     * Flag to togle displaying the edit button
     *
     * @type {boolean}
     * @memberof RecapAdditionalSecurityComponent
     */
    @Input() showEditButton: boolean;
    constructor() {
        this.stageChange = new EventEmitter<string>();
    }

    propertyCategory: object = {
        0: 'Residential',
        2: 'Commercial and Semi-Commercial',
        3: 'Land',
    };


    repaymentStrategyType: object = {
        0: 'Init',
        7: 'Other',
        8: 'Property Sale',
        11: 'Remortgage',
        12: 'Pension lump sum or similar',
        13: 'Inheritance'
    };

    get Address(): string {
        return this.additionalDetails['FullAddress'];
    }

    get HasAdditionalSecurity(): boolean {
        return (!_.isNil(this.additionalDetails['PropertyType'])
            && !_.isEmpty(this.additionalDetails['PropertyType']));
    }

    get PropertyType(): string {
        return this.additionalDetails['PropertyType'];
    }

    get PurchasePrice(): string {
        return '£' + numeral(this.additionalDetails['PurchasePrice']).format('0,0');
    }

    get Valuation(): string {
        return '£' + numeral(this.additionalDetails['Valuation']).format('0,0');
    }

    get DateLoanRequired(): string {
        return moment(this.additionalDetails['DateLoanRequired']).format('DD/MM/YYYY');
    }

    private get ExistingCharges(): Object {
        if (_.isNil(this.additionalDetails)) return null;
        return this.additionalDetails['ExistingCharges'];
    }

    get HasExistingCharges(): boolean {
        return (!_.isEmpty(this.ExistingCharges) &&
            _.isNil(this.ExistingCharges['ExistingChargeValue']) === false);
    }

    get ExistingChargeCompany(): string {
        if (_.isNil(this.ExistingCharges)) return '';
        return this.ExistingCharges['ExistingChargeCompany'];
    }

    get HasSecuredDebt(): boolean {
        return (!_.isEmpty(this.ExistingCharges) &&
            _.isNil(this.ExistingCharges['SecuredDebtValue']) === false);
    }

    get ExistingChargeValue(): string {
        if (_.isNil(this.ExistingCharges)) return '';
        return '£' + numeral(this.ExistingCharges['ExistingChargeValue']).format('0,0');
    }

    get RepaymentStrategy(): string {
        // tslint:disable-next-line:max-line-length
        return this.repaymentStrategyType[_.toInteger(this.additionalDetails['RepaymentStrategy'])];
    }

    get PropertyCategory(): string {
        // tslint:disable-next-line:max-line-length
        return this.propertyCategory[_.toInteger(this.additionalDetails['PropertyCategoryId'])];
    }

    get PurchaseDate(): string {
        return moment(this.additionalDetails['PurchaseDate']).format('MM/YYYY');
    }


    get SecuredDebtValue(): string {
        if (_.isNil(this.ExistingCharges)) return '';
        return '£' + numeral(this.ExistingCharges['SecuredDebtValue']).format('0,0');
    }
    ngOnInit() {
    }
    /**
     * emit stage change when edit button clicked
     *
     * @memberof RecapLoanDetailsComponent
     */
    editButtonClicked(): void {
        this.stageChange.emit('tad_stage_additional_loan_details');
    }
}
